export default __webpack_public_path__ + "static/media/user.1431a017.svg";